mutation TestSnippetStatus($input: SnippetStatusTestInput!) {
    snippetStatusTest(input: $input) {
        snippetTestStatus {
            status
            lastTestedTime
            embeddedDomain
            loaderDomain
        }
    }
}
